'use client'

import classNames from 'classnames'
import React, { ChangeEvent, FormEvent, FunctionComponent } from 'react'
import { Button } from '@/app/_components/Button'
import Input from '@/app/_components/Forms/Input/Input'
import styles from './SingleInputForm.module.css'

type SingleInputFormProps = {
  ref: React.Ref<HTMLInputElement>
  prefix: string
  name: string
  value: string
  label: string
  placeholder?: string
  buttonText?: string
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
  onSubmit: (e: FormEvent<HTMLFormElement>) => void
  hasSubmitted: boolean
  isLoading: boolean
  isValid: boolean
  submitError: boolean
  submitSuccess: boolean
  errorMessage?: string
  successMessage?: string
  // pattern?: string
  // maxLength?: number
  // inputMode?: 'numeric' | 'text'
  // required?: boolean
}

const SingleInputForm: FunctionComponent<SingleInputFormProps> = ({
  ref,
  isLoading,
  prefix,
  name,
  value,
  label,
  hasSubmitted,
  placeholder,
  buttonText = 'Apply',
  onSubmit,
  onChange,
  isValid,
  submitError,
  submitSuccess,
  errorMessage,
  successMessage,
}: SingleInputFormProps) => (
  <form className={styles.Form} onSubmit={onSubmit} noValidate>
    <div className={classNames(styles.Wrapper, { [styles.ErrorState]: submitError && (errorMessage || !isValid) })}>
      <Input
        placeholderText={placeholder}
        name={name}
        ref={ref}
        testId={prefix}
        hasErrors={!isValid || submitError}
        hasSubmitted={hasSubmitted}
        onChange={onChange}
        value={value}
        label={label}
        isSingleInput
      />
      <Button
        className="submit-btn"
        size="sm"
        type="submit"
        variant="inverse"
        weight="medium"
        testId={`${prefix}-button`}
        disabled={!isValid}
      >
        <span className={classNames({ [styles.Loading]: isLoading })}>
          {buttonText}
        </span>
      </Button>
    </div>
    <div
      className={styles.NotificationWrapper}
      aria-atomic="true"
      aria-live="polite"
    >
      {submitError && (
        <div className={classNames(styles.Message, styles.Error)} data-testid={`${prefix}-error`}>
          {errorMessage}
        </div>
      )}
      {submitSuccess && (
        <div className={classNames(styles.Message, styles.Success)} data-testid={`${prefix}-success`}>
          {successMessage}
        </div>
      )}
    </div>
  </form>
)

export default SingleInputForm
